import React, { Component } from 'react'
import { toggleTextingForSBR } from 'services/Manager';
import './ToggleTextingForSBRContainer.less'

const initialState = {
    enableTexting: true
}
class ToggleTextingForSBRContainer extends Component {

    constructor(props){
        super(props);
        this.state = initialState;
    }

    componentDidMount(){
        this.setState({enableTexting: this.props.enableTexting});
    }

    componentDidUpdate(prevProps){
        if(prevProps.enableTexting != this.props.enableTexting){
            this.setState({enableTexting: this.props.enableTexting});
        }
    }

    onButtonClick = async (enabled) => {
        const res = await toggleTextingForSBR(this.props.sbrID, enabled);
        if(res.resStatus == 200){
            this.setState({enableTexting: enabled});
        }
    }
    
    render() {
        return (
            <div className='toggle-texting-container'>
                {this.state.enableTexting ? <button className='btn-toggle disable' onClick={() => this.onButtonClick(false)}>Disable Texting</button> :
                    <button className='btn-toggle enable' onClick={() => this.onButtonClick(true)}>Enable Texting</button>
                }
            </div>

        )
    }
}

export default ToggleTextingForSBRContainer